import React, { FC } from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { LabMaterial } from 'models/material';
import { useTranslation } from 'react-i18next';
import AddMaterialForm from './add-material-form.component';

type AddMaterialDialogProps = {
    dialogOpen: boolean;
    onCloseDialog: () => void;
    onAddMaterial: (material: LabMaterial) => void;
};
const AddMaterialDialog: FC<AddMaterialDialogProps> = ({
    dialogOpen,
    onCloseDialog,
    onAddMaterial,
}: AddMaterialDialogProps) => {
    const { t: translate } = useTranslation('orders');
    return (
        <Dialog fullWidth maxWidth="md" open={dialogOpen}>
            <DialogTitle>{translate('orders:ADD_MATERIAL')}</DialogTitle>
            <AddMaterialForm onCloseDialog={onCloseDialog} onAddMaterial={onAddMaterial} />
        </Dialog>
    );
};

export default AddMaterialDialog;
